import { render } from "./CookieBannerAtom.vue?vue&type=template&id=4e661d60&scoped=true"
import script from "./CookieBannerAtom.vue?vue&type=script&lang=js"
export * from "./CookieBannerAtom.vue?vue&type=script&lang=js"

import "./CookieBannerAtom.vue?vue&type=style&index=0&id=4e661d60&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e661d60"]])

export default __exports__